import React, { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import {
  isExpiredAtom,
  planDetailAtom,
  planDetailRecommendedAtom,
  subjectSubscriptionAtom,
  userDetailAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import TrialPlanCardDescription from '@components/subscription/overview/TrialPlanCardDescription';
import {
  resetToDefaultNavbarState,
  setNavbarWithTitleNoTopNavbar,
} from '@atom/navbarAtom';
import ActivePlanDetail from '@components/subscription/overview/detail/ActivePlanDetail';
import RecommendedPlanDetail from '@components/subscription/overview/detail/RecommendedPlanDetail';
import WarningNote from '@components/subscription/overview/WarningNote';
import SubscriptionActionButton from '@components/subscription/overview/SubscriptionActionButton';
import { BreadcrumbItemsProp } from 'geniebook-ui/dist/components/Breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from 'geniebook-ui/dist';

const PlanOverviewMain = () => {
  const subscription = useAtomValue(subjectSubscriptionAtom);
  const overviewPlan = useAtomValue(planDetailAtom);
  const recommendedPlan = useAtomValue(planDetailRecommendedAtom);
  const isSelectedExpired = useAtomValue(isExpiredAtom);
  const userDetail = useAtomValue(userDetailAtom);

  const navigate = useNavigate();
  const { subject } = useParams();
  const breadcrumbItems: BreadcrumbItemsProp[] = [
    {
      title: 'Subject',
      onClick: () => navigate('/subscription'),
    },
  ];
  if (!isSelectedExpired) {
    breadcrumbItems.push({
      title: subscription?.display_name ?? '',
      onClick: () => navigate('/subscription/' + subject),
    });
  }
  breadcrumbItems.push({
    title: 'Plan Overview',
  });

  useEffect(() => {
    if (subscription?.is_trial_plan) {
      setNavbarWithTitleNoTopNavbar('Upgrade Plan');
    } else {
      setNavbarWithTitleNoTopNavbar('Plan Overview');
    }
    return () => {
      resetToDefaultNavbarState();
    };
  }, [subscription]);

  const planDetail = subscription?.is_trial_plan
    ? recommendedPlan
    : overviewPlan;

  if (!subscription || !planDetail || !userDetail) {
    return null;
  }

  return (
    <div>
      <div className={'mb-6 max-lg:hidden'}>
        <Breadcrumb
          className={'[&_svg:first-of-type]:hidden'}
          items={breadcrumbItems}
        />
      </div>
      {subscription.is_trial_plan && (
        <div className={'lg:mb-6 max-lg:mb-4'}>
          <TrialPlanCardDescription />
        </div>
      )}
      <div className={'max-lg:mb-4 lg:mb-6'}>
        {subscription.is_trial_plan ? (
          <RecommendedPlanDetail planDetail={planDetail} />
        ) : (
          <ActivePlanDetail planDetail={planDetail} />
        )}
      </div>
      <WarningNote
        className={'max-lg:mb-4 lg:mb-6'}
        planDetail={planDetail}
        subscription={subscription}
      />
      <SubscriptionActionButton
        planDetail={planDetail}
        subscription={subscription}
        userDetail={userDetail}
      />
    </div>
  );
};

export default PlanOverviewMain;
